import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import Input from '../../../components/Inputs/Input/Input';
import Modal from '../../../components/Modals/Modal/Modal';
import * as Types from '../../../../utils/types/Types';
import * as Body from '../Styles';
import * as defines from '../../../../utils/defines/Defines';
import * as Functions from '../../../../utils/functions/Functions';
import Button from '../../../components/Buttons/Button/Button';
import { State } from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { AcessLevelProps } from '../../../redux/acessLevel/actionsType';
import axios from 'axios';
import { verifyEmail } from '../../../../utils/functions/Functions';
import { useNavigate } from 'react-router-dom';
import SearchIcon from '../../../../assets/icons/Search.svg';


type ModalDeleteProps = {
	toggle: Dispatch<SetStateAction<boolean>>;
	idUsuario: string;
	nome: String;
	action: any;
};

export const ModalDeleteUser: React.FC<ModalDeleteProps> = ({
	toggle,
	idUsuario,
	nome,
	action,
}) => {
	return (
		<Modal title="">
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				<Body.Text style={{ marginBottom: '20px' }}>
					Você tem certeza que deseja excluir o usuário &nbsp;
					<strong style={{ color: defines.BlueTec }}>
						{nome}
					</strong>?
				</Body.Text>
				<Body.Text style={{ marginBottom: '20px' }}>
					Essa ação é permanente e não pode ser desfeita.
				</Body.Text>
				<Body.Row>
					<Button
						text="Excluir"
						width={200}
						color="red"
						action={() => action()}
					/>
					<Button
						text="Cancelar"
						width={200}
						action={() => toggle(false)}
					/>
				</Body.Row>
			</div>
		</Modal>
	);
};
